import { render, staticRenderFns } from "./new.submission-forms.page.vue?vue&type=template&id=142ebab6&"
import script from "./new.submission-forms.page.vue?vue&type=script&lang=js&"
export * from "./new.submission-forms.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports